import React from "react"
import { connect } from "react-redux"
import {
  refresh,
  openPage,
  clear,
  closeInventory,
  deleteInventory,
  editInventory,
  exportData,
  search,
  sort,
} from "../ducks/tabularData/inventory"
import { getMeasures } from "../ducks/measures"
import { authorize } from "../decorators/authorize"
import { inventoriesPage, inventoryPage } from "../config/routesInfo"
import Info from "../components/Info"
import { Grid, Form, Button, Input, Icon, Modal } from "semantic-ui-react"
import Pagination from "../components/Pagination"
import bind from "bind-decorator"
import InventoryStockCard from "../components/InventoryStockCard"
import copy from "copy-to-clipboard"
import { alertTypes, showMessage } from "../ducks/alerts"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import EditableTable from "../components/EditableTable"

const columns = [
  {
    title: "employe",
    name: "authorlogin",
    dateType: "string",
    sortable: true,
  },
  {
    title: "barcode",
    name: "barcode",
    dateType: "string",
    sortable: true,
  },
  {
    title: "supplyTitle",
    name: "nameinventory",
    dateType: "string",
    render: (item, t) => (
      <>
        {item.stock.db && (
          <p>{t("In storage") + " " + (item.supplyTitle.db || " ")}</p>
        )}
        <p>{t("new1") + " " + (item.supplyTitle.inventory || " ")}</p>
      </>
    ),
    editable: true,
    sortable: true,
  },
  {
    title: "price",
    name: "salepriceinventory",
    dateType: "string",
    render: (item, t) => (
      <>
        {item.stock.db && (
          <p>{t("In storage") + " " + (item.price.db || " ")}</p>
        )}
        <p>{t("new2") + " " + (item.price.inventory || " ")}</p>
      </>
    ),
    sortable: true,
  },
  {
    title: "purchasePrice",
    name: "purchasepriceinventory",
    dateType: "string",
    render: (item, t) => (
      <>
        {item.stock.db && (
          <p>{t("In storage") + " " + (item.purchasePrice.db || " ")}</p>
        )}
        <p>{t("new2") + " " + (item.purchasePrice.inventory || " ")}</p>
      </>
    ),
    sortable: true,
  },
  {
    title: "stock",
    name: "inventorystockid",
    render: (item, t) => (
      <>
        {item.stock.db && (
          <p>{t("In storage") + " " + (item.stock.db || " ")}</p>
        )}

        <p>{t("new3") + " " + (item.stock.inventory || " ")}</p>
      </>
    ),
    sortable: true,
  },
  {
    title: "unitsMeasuringFull",
    name: "measureid",
    dateType: "string",
    render: (item, t, measures) => (
      <>
        {item.stock.db && (
          <p>
            {t("In storage") +
              " " +
              item.unitsMeasuringFull.map((el) => " " + el.name)}
          </p>
        )}

        <p>
          {t("new2") +
            " " +
            (measures.find((el) => el.id === item.measureId)
              ? measures.find((el) => el.id === item.measureId).name
              : "")}
        </p>
      </>
    ),
    sortable: true,
  },
]

@authorize(...inventoryPage.permissions)
@withRouter
@withTranslation()
@connect(
  (state) => ({
    activeFilters: state.currentInventory.filters,
    sortedBy: state.currentInventory.sortedBy,
    sortedAsc: state.currentInventory.sortedAsc,
    data: state.currentInventory.data,
    // toButton: state.inventories.data,
    isLoading: state.currentInventory.pendingRequests > 0,
    pagesCount: state.currentInventory.totalPages,
    currentPage: state.currentInventory.currentPage,
    measures: state.measures.measures,
  }),
  (dispatch) => ({
    onSearch: (...data) => dispatch(search(...data)),
    refresh: (...data) => dispatch(refresh(...data)),
    clear: () => dispatch(clear()),
    onPageSelect: (...data) => dispatch(openPage(...data)),
    close: (...data) => dispatch(closeInventory(...data)),
    delete: (data) => dispatch(deleteInventory(data)),
    edit: (...data) => dispatch(editInventory(...data)),
    showMessage: (...data) => dispatch(showMessage(...data)),
    exportData: (...data) => dispatch(exportData(...data)),
    getMeasures: () => dispatch(getMeasures()),
    onSort: (...data) => dispatch(sort(...data)),
  }),
)
export default class InventoryPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: "",
      isExporting: false,
      modal: false,
      selected: <></>,
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.props.refresh({ inventoryId: this.props.match.params.inventoryId })
    this.props.getMeasures()
  }

  select = (el) => {
    const { inventoryId } = this.props.match.params
    const data = this.props.data
    if (data.inventoryStocks) {
      data.inventoryStocks.map((item, i) => {
        if (el.inventoryStockId === item.inventoryStockId) {
          this.setState({
            modal: true,
            selected: (
              <InventoryStockCard
                data={item}
                onEdit={this.props.edit}
                measures={this.props.measures}
                options={item.measures.map((measure) => ({
                  value: measure.measureId,
                  key: measure.measureId,
                  text: measure.name,
                }))}
                inventoryId={inventoryId}
                completed={data.completed}
                closeModal={() => {
                  this.setState({ modal: false, selected: <></> })
                }}
              />
            ),
          })
        }
      })
    }
  }

  componentWillUnmount() {
    this.props.clear()
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  setQuery({}, { value }) {
    this.setState({
      searchQuery: value,
    })
  }

  @bind
  search() {
    const { searchQuery } = this.state
    const { onSearch } = this.props
    onSearch(searchQuery)
  }

  @bind
  copyLink() {
    const { inventoryId } = this.props.match.params
    const { t } = this.props
    const link = "http://smartkassa.kz/inventory/?id=" + inventoryId
    copy(link)
    this.props.showMessage(t("Link copied"), alertTypes.success)
  }

  @bind
  closeInventory() {
    this.props.close(() => {
      window.router.push(inventoriesPage.path)
      // this.props.history.push("/inventories")
    })
    this.props.refresh({ inventoryId: this.props.match.params.inventoryId })
  }

  @bind
  deleteInventory() {
    this.props.delete(() => {
      this.props.history.push("/inventories")
    })
    this.props.refresh({ inventoryId: this.props.match.params.inventoryId })
  }

  @bind
  stopExporting() {
    this.setState({
      isExporting: false,
    })
  }

  @bind
  exportInventory() {
    if (this.state.isExporting) {
      return
    }
    this.setState({
      isExporting: true,
    })
    this.props.exportData(this.stopExporting)
  }

  render() {
    const {
      activeFilters,
      sortedBy,
      sortedAsc,
      data,
      toButton,
      isLoading,
      currentPage,
      pagesCount,
      onPageSelect,
      measures,
      edit,
      onSort,
      t,
    } = this.props
    const { inventoryId } = this.props.match.params
    const { searchQuery, isExporting } = this.state
    let inventoryStockCards = null
    if (data.inventoryStocks) {
      inventoryStockCards = data.inventoryStocks.map((item, i) => {
        return (
          <Grid.Column key={i} tablet={16} computer={4}>
            <InventoryStockCard
              data={item}
              onEdit={edit}
              measures={measures}
              options={item.measures.map((measure) => ({
                value: measure.measureId,
                key: measure.measureId,
                text: measure.name,
              }))}
              inventoryId={inventoryId}
              completed={data.completed}
            />
          </Grid.Column>
        )
      })
    }
    const tableData = {
      columns,
      isLoading,
      data: data.inventoryStocks
        ? data.inventoryStocks.map((el) => ({
            inventoryStockId: el.inventoryStockId,
            authorlogin: el.authorLogin,
            barcode: el.barcode,
            supplyTitle: el.name,
            price: el.salePrice,
            stock: el.remainder,
            purchasePrice: el.purchasePrice,
            unitsMeasuringFull: el.measures || [],
            measureId: el.measureId,
          }))
        : [],
      onSort,
      sortedBy,
      sortedAsc,
    }
    const link = "http://smartkassa.kz/inventory/?id=" + inventoryId
    return (
      <div className="editable-table-holder">
        <h2>
          {t("Inventory")} №{inventoryId}
          <Info
            text={
              <div>
                <p />
                <ul>
                  <li>{t("startInventory")}</li>
                  <li>{t("Complete inventory at the end of the inventory")}</li>
                  <li>{t("Delete inventory")}</li>
                  <li>{t("Export inventory")}</li>
                </ul>
              </div>
            }
          />
        </h2>
        <h3>
          <Button>
            <a href={link} target="blank">
              {t("redirectInventory")}
            </a>{" "}
          </Button>
          <Icon
            name="linkify"
            size="small"
            link
            circular
            onClick={this.copyLink}
          />
          {!data.completed && (
            <>
              <Button
                className="close-inventory-button"
                content={t("toComplete")}
                color="green"
                loading={isLoading}
                onClick={this.closeInventory}
                disabled={
                  data.length === undefined && data.inventoryStocks.length === 0
                }
              />
              <Button
                className="close-inventory-button"
                content={t("delete")}
                loading={isLoading}
                color="red"
                // loading={isLoading}
                onClick={this.deleteInventory}
              />
            </>
          )}
        </h3>

        <Grid>
          <Grid.Row verticalAlign="middle">
            <Grid.Column mobile={16} tablet={6} computer={8}>
              <Form onSubmit={this.search}>
                <Form.Field>
                  <Input
                    className="editable-table-holder-search"
                    value={searchQuery}
                    onChange={this.setQuery}
                    placeholder={t("searchWithBarcodeName")}
                  />
                </Form.Field>
              </Form>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={10} computer={8}>
              <div style={{ display: "flex" }}>
                <Pagination
                  max={4}
                  count={pagesCount}
                  current={currentPage}
                  onSelect={onPageSelect}
                />
                <Button
                  className="export-button"
                  content="Экспорт"
                  color="green"
                  loading={isExporting}
                  onClick={this.exportInventory}
                  disabled={!data.completed}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {/* <Grid className="inventory-stock-holder">{inventoryStockCards}</Grid> */}
        <EditableTable
          {...tableData}
          noOptions
          onSelect={this.select}
          measures={measures}
          setProdName={(a) => a}
        />
        <Modal
          open={this.state.modal}
          onClose={() => this.setState({ modal: false, selected: <></> })}
          style={{
            width: "max-content",
            height: "max-content",
            marginTop: "-40vh",
            marginLeft: "-40vw",
          }}
          centered={false}
        >
          {this.state.selected}
        </Modal>
      </div>
    )
  }
}
